/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { CircleStackIcon, PlusIcon } from '@heroicons/react/24/outline';

interface EmptyStateProps {
    type: 'no-project' | 'no-buckets' | 'no-results';
    onCreateBucket?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type, onCreateBucket }) => {
    const content = {
        'no-project': {
            title: 'Select a Project',
            description: 'Choose a project to view and manage its storage buckets',
            showButton: false,
        },
        'no-buckets': {
            title: 'No buckets yet',
            description: 'Create your first S3-compatible storage bucket',
            showButton: true,
        },
        'no-results': {
            title: 'No matching buckets',
            description: 'Try adjusting your search or filters',
            showButton: false,
        },
    };

    const { title, description, showButton } = content[type];

    return (
        <div className="text-center py-12 bg-gray-900 rounded-xl border border-gray-800">
            <CircleStackIcon className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-white mb-2">{title}</h3>
            <p className="text-gray-400 mb-4">{description}</p>
            {showButton && onCreateBucket && (
                <button
                    onClick={onCreateBucket}
                    className="btn-primary inline-flex items-center gap-2"
                >
                    <PlusIcon className="w-4 h-4" />
                    New Bucket
                </button>
            )}
        </div>
    );
};

export default EmptyState;
